import { put, call, takeEvery } from 'typed-redux-saga';
import { toast } from 'react-toastify';

import combinedActions from '~redux/combinedActions';
import { store } from '~redux/store';

import { GatewayResponseStatus } from '~types/gateway';
import { SagaWatcherReturnType } from '~types/saga';

import { ErrorMessages } from '~utils/constants';
import ReportGateway from '~apis/report';
import UtilFunctions from '~utils/functions';
import { FundTypeEnum, MetalTypeEnum } from '~utils/enums';

export default function* watchGetInventoryReceivedReportListing(api: ReportGateway): SagaWatcherReturnType {
    yield takeEvery('report/reportGetInventoryReceivedReportTransactionListingAttempt', handleGetInventoryReceivedReportListing, api);
}

function* handleGetInventoryReceivedReportListing(api: ReportGateway) {
    const reduxState = store.getState();
    const authToken = reduxState.auth.userDetails.authToken;
    const {
        index,
        filters: {
            dateFrom,
            dateTo,
            branchName,
            productId,
            metalType,
            fundType,
            serialNo
        }
    } = reduxState.report.inventoryReport.inventoryReceivedReportTransactionListing;

    const allBranches = reduxState.branch.allBranches;
    const branchCode = allBranches.find(branch => branch.branchName === branchName)?.branchCode;

    const response = yield* call([api, api.getInventoryReceivedReportListing], {
        authToken,
        index,
        productId: productId !== 0 ? productId : undefined,
        dateFrom: dateFrom ? dateFrom : undefined,
        dateTo: dateTo ? dateTo : undefined,
        branchCode: branchCode ? branchCode : undefined,
        metalType: metalType ? UtilFunctions.Misc.getEnumValueByKey(MetalTypeEnum, metalType.split(' ').join('')) : undefined,
        fundType: fundType ? UtilFunctions.Misc.getEnumValueByKey(FundTypeEnum, fundType.split(' ').join('')) : undefined,
        serialNo: serialNo ? serialNo : undefined,
    });

    if (response.status === GatewayResponseStatus.Error) {
        yield put(combinedActions.reportGetInventoryReceivedReportTransactionListingFailure(response.message || ErrorMessages.GenericError));
        toast.error(response.message || ErrorMessages.GenericError);
        return;
    }

    if (response.status === GatewayResponseStatus.Success) {
        yield put(combinedActions.reportGetInventoryReceivedReportTransactionListingSuccess(response.data));
    }
}
